import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const MyPresets = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '{zinc.50}',
          100: '{zinc.100}',
          200: '{zinc.200}',
          300: '{zinc.300}',
          400: '{zinc.400}',
          500: '{zinc.500}',
          600: '{zinc.600}',
          700: '{zinc.700}',
          800: '{zinc.800}',
          900: '{zinc.900}',
          950: '{zinc.950}',
        },
      },
      dark: {
        primary: {
          50: '{blue.50}',
          100: '{blue.100}',
          200: '{blue.200}',
          300: '{blue.300}',
          400: '{blue.400}',
          500: '{blue.500}',
          600: '{blue.600}',
          700: '{blue.700}',
          800: '{blue.800}',
          900: '{blue.900}',
          950: '{blue.950}',
        },
      },
    },
  },
  components: {
    tag: {
      css: `
        .p-tag {
          border: 1px solid #1F2937;
        }

        .p-tag-success {
          border-color: #125934;
        }

        .p-tag-danger {
          border-color: #A30D11;
        }

        .p-tag-warn {
          border-color: #803E00;
        }

        .p-tag-info {
          border-color: #0052A5;
        }
      `,
      colorScheme: {
        light: {
          primary: {
            background: '#D1D5DB',
            color: '#1F2937',
          },
          success: {
            background: '#EBF9F1',
            color: '#125934',
          },
          danger: {
            background: '#FBE7E8',
            color: '#A30D11',
          },
          warn: {
            background: '#FBF7F1',
            color: '#803E00',
          },
          info: {
            background: '#F3F9FE',
            color: '#0052A5',
          },
        },
        dark: {
          primary: {
            background: '#D1D5DB',
            color: '#1F2937',
          },
          success: {
            background: '#EBF9F1',
            color: '#125934',
          },
          danger: {
            background: '#FBE7E8',
            color: '#A30D11',
          },
          warn: {
            background: '#FBF7F1',
            color: '#803E00',
          },
          info: {
            background: '#F3F9FE',
            color: '#0052A5',
          },
        },
      },
    },
  },
});
